import { ROOT } from "../constants/route.constant";

const appConfig = {
  authenticatedEntryPath: ROOT,
  unAuthenticatedEntryPath: ROOT,
  enableMock: true,
};

export default appConfig;
